import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from './supabaseClient';
import './Dashboard.css';

function Dashboard() {
  const [session, setSession] = useState(null);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Get initial session
    supabase.auth.getSession().then(({ data: { session }, error }) => {
      if (!error) setSession(session);
    });

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    // Cleanup subscription
    return () => subscription.unsubscribe();
  }, []);

  const handleMagicLink = async (e) => {
    e.preventDefault();
    try {
      // Call the Netlify Function
      const response = await fetch('/.netlify/functions/requestMagicLink', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.toLowerCase() }), // Normalize email
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        setEmail(''); // Clear the input
      } else {
        setMessage('Error: ' + data.error);
      }
    } catch (error) {
      setMessage('Error sending request: ' + error.message);
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setSession(null);
  };

  return (
    <div className="App">
      {session ? (
        <div className="dashboard">
          <h1>lolhax.dev</h1>
          <p>Welcome, {session.user?.email || 'Unknown'}!</p>
          <div className="tools-grid">
            <Link to="/guyferrari" className="tool-card">
              <h3>Guy Ferrari</h3>
              <p>Driving Simulator</p>
            </Link>
            <div className="tool-card">
              <h3>placeholder</h3>
              <p>(coming soon)</p>
            </div>
            <div className="tool-card">
              <h3>Ghiblifi</h3>
              <p>(coming soon)</p>
            </div>
            <div className="tool-card">
              <h3>Placeholder 4</h3>
              <p>Placeholder 4 description</p>
            </div>
            <div className="tool-card">
              <h3>Placeholder 5</h3>
              <p>Placeholder 5 description</p>
            </div>
            <div className="tool-card">
              <h3>Placeholder 6</h3>
              <p>Placeholder 6 description</p>
            </div>
            <div className="tool-card">
              <h3>Placeholder 7</h3>
              <p>Placeholder 7 description</p>
            </div>
            <div className="tool-card">
              <h3>Placeholder 8</h3>
              <p>Placeholder 8 description</p>
            </div>
            <div className="tool-card">
              <h3>Placeholder 9</h3>
              <p>Placeholder 9 description</p>
            </div>
          </div>
          <button onClick={handleLogout}>Logout</button>
        </div>
      ) : (
        <>
          <h1>Login to lolhax.dev</h1>
          <form onSubmit={handleMagicLink}>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
            <button type="submit">Send Magic Link</button>
          </form>
          {message && <p>{message}</p>}
        </>
      )}
    </div>
  );
}

export default Dashboard;